import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Loader } from "../../atoms/Loader";

function RelatedList(props) {
  const {
    children,
    tabIndex,
    index,
    orgId,
    apiKey,
    dataCenterUrl,
    zApiKey,
    ...other
  } = props;

  const [loading, setLoading] = useState(false);

  if (tabIndex != index) {
    return <></>;
  }

  if (loading) {
    return <Loader />;
  }

  if (!orgId || !apiKey || !dataCenterUrl || !zApiKey) {
    return (
      <>
        Some of the data are missing
        {orgId}-{apiKey}-{dataCenterUrl}-{zApiKey}
      </>
    );
  }

  return (
    <div
      role="tabpanel"
      hidden={tabIndex !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box sx={{ p: 3 }}>This is Related list</Box>
    </div>
  );
}

export default RelatedList;
